module.exports = __webpack_public_path__ + "img/user_card_exchange.61b34770.png";